import "./ClaimsCenter.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ReportAnIncident from "./sections/ReportAnIncident";
import ClaimsProcess from "./sections/ClaimsProcess";
import AgencyFooter from "@/reusable_sections/Footer";
export default function ClaimsCenterPage() {
  return <div>
      <MainNavigation />
      <ReportAnIncident />
      <ClaimsProcess />
      <AgencyFooter />
    </div>;
}